import React from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import NumberFormat from "react-number-format";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { ProduccionReportadaApi } from "../api/ProduccionReportadaApi";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { PESO_KG_PACA_PRODUCCION } from "../../../../../../../../utility/constants";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";

export const ProdReportadaForm = (props) => {
    const { GetProduccionActual } = props;

    // formulario
    const {
        control: formControl,
        register: formRegister,
        formState: { errors },
        getValues: formGetValues,
        setValue: formSetValue,
        watch: formWatch,
        trigger: validateForm,
        reset: resetForm,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            tipo_turno: {
                value: "actual",
                label: "Actual",
            },
        },
    });

    const { getProductosTerminados, registrarEnvio, deleteEnvio, cargando } =
        ProduccionReportadaApi();

    const loadProductos = useDebouncedAsyncSelect(function (search) {
        return getProductosTerminados({ search: search });
    });

    const RegistrarEnvio = async () => {
        try {
            const isValid = await validateForm();
            if (!isValid) return;

            const cantidad_pacas = formGetValues("cantidad_pacas");
            const tipo_producto = formGetValues("tipo_producto");
            const tipo_turno = formGetValues("tipo_turno");

            if (!cantidad_pacas) {
                NotificationManager.error(
                    "Debe ingresar la cantidad de pacas producidas",
                    "Error",
                    3000,
                );
                return;
            }

            const data = {
                cantidad_pacas: cantidad_pacas || 0,
                producto_terminado_id: tipo_producto ? tipo_producto.id : null,
                tipo_turno: tipo_turno ? tipo_turno.value : null,
            };

            await registrarEnvio(data);

            NotificationManager.success(
                "Envío registrado correctamente",
                "Éxito",
                3000,
            );

            // limpiar campos formulario: cantidad pacas, producto terminado
            formSetValue("cantidad_pacas", "");
            // formSetValue("tipo_producto", null);

            GetProduccionActual();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al registrar envío",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const cantidadPacas = formWatch("cantidad_pacas") || 0;

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();

                RegistrarEnvio();
            }}
            autoComplete="on"
            className="mb-3"
        >
            <h5 className="mb-2">Producción</h5>
            <div className="formulario-fields-row mt-0 gap-1rem flex-wrap">
                <div className="formulario-field min-w-150">
                    <label htmlFor="tipo_turno" className="text-nowrap">
                        Turno
                    </label>

                    <Controller
                        name="tipo_turno"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={[
                                    {
                                        value: "actual",
                                        label: "Actual",
                                    },
                                    {
                                        value: "anterior",
                                        label: "Anterior",
                                    },
                                ]}
                                placeholder="Seleccionar"
                            />
                        )}
                    />
                    {errors.tipo_turno && (
                        <small className="text-danger">
                            {errors.tipo_turno.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field min-w-150">
                    <label htmlFor="tipo_producto" className="text-nowrap">
                        Tipo de producto
                    </label>

                    <Controller
                        name="tipo_producto"
                        control={formControl}
                        rules={{
                            required: "Debe seleccionar un producto",
                        }}
                        render={({ field }) => (
                            <AsyncSelect
                                {...field}
                                className="react-select-container"
                                isSearchable
                                isClearable
                                defaultOptions
                                loadOptions={loadProductos}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(selected) => {
                                    field.onChange(selected);
                                }}
                            />
                        )}
                    />
                    {errors.tipo_producto && (
                        <small className="text-danger">
                            {errors.tipo_producto.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field min-w-150">
                    <label htmlFor="cantidad_pacas" className="text-nowrap">
                        Cant. pacas producidas
                    </label>

                    <NumberField
                        control={formControl}
                        name="cantidad_pacas"
                        errors={errors}
                        allowNegative={false}
                        rules={{
                            min: {
                                value: 0,
                                message: "La cantidad no puede ser negativa",
                            },
                        }}
                        decimalScale={0}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label htmlFor="peso_paca" className="text-nowrap">
                        Peso paca
                    </label>

                    <NumberFormat
                        className="form-control"
                        value={PESO_KG_PACA_PRODUCCION}
                        suffix=" Kg"
                        thousandSeparator=","
                        disabled
                        placeholder="0 kg"
                    />
                </div>
                
                <div className="formulario-field min-w-150">
                    <label htmlFor="operador_bascula" className="text-nowrap">
                        Kg secos en pacas
                    </label>

                    <NumberFormat
                        className="form-control"
                        value={cantidadPacas * PESO_KG_PACA_PRODUCCION}
                        suffix=" Kg"
                        thousandSeparator=","
                        disabled
                        placeholder="0 kg"
                    />
                </div>

                <div
                    className="formulario-field mb-0 ml-auto no-flex"
                    style={{ maxHeight: "57px" }}
                >
                    <button
                        className="btn btn-primary text-nowrap mt-auto"
                        type="submit"
                        disabled={cargando}
                    >
                        Agregar
                    </button>
                </div>
            </div>
        </form>
    );
};
